import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgUploadV2Component } from './img-upload-v2.component';

@NgModule({
  declarations: [ImgUploadV2Component],
  imports: [CommonModule],
  exports: [ImgUploadV2Component]
})
export class ImgUploadV2Module {}
